import { Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content max-content;
  align-items: center;
  background: #fff;
  grid-gap: 0 8px;
  z-index: 3;
  position: relative;
  padding: 16px 20px 16px 14px;
  position: sticky;
  top: 0;
`;

export const ScrollContainer = styled.div`
  position: sticky;
  top: 100px;
  background: transparent;
  transition: all 0.2s ease-in;
`;

export const BackIcon = styled.img`
  height: 24px;
  width: 24px;
`;

export const Location = styled.img`
  height: 20px !important;
  width: 20px !important;
`;

export const City = styled.div`
  color: #040222;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const FilterWrapper = styled.div<{ showTopElement: boolean }>`
  padding: 20px;
  display: flex;
  overflow: auto;
  width: 100%;
  position: sticky;
  top: ${(props: any) => (props.showTopElement ? "55px" : 0)};
  background: #fff;
  z-index: 2;
  transition: all 0.2s ease-in;

  ${(props: any) =>
    props.showTopElement &&
    "box-shadow: 0px 4px 6px -2px rgba(54, 53, 76, 0.08);padding: 8px 20px 12px;"};

  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    flex-shrink: 0;
  }
`;

export const Tag = styled.div`
  border-radius: 24px;
  border: 1px solid #e7e7f0;
  background: #fff;
  padding: 8px 16px;
  color: #040222;
  text-align: center;
  font-size: 14px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 8px 0 0;
  position: relative;
  transition: all 0.2s ease-in;

  & > span {
    display: block;
    height: 20px;
    width: 20px;
    margin: 0 0 0 2px;
    animation: slideRight 0.2s ease-in forwards;
    opacity: 0;

    @keyframes slideRight {
      0% {
        opacity: 0;
        transform: translateX(-20px);
      }
      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }

  & > span::after,
  & > span::before {
    content: "";
    background: #36354c;
    height: 16px;
    width: 1.5px;
    border-radius: 2px;
    position: absolute;
    display: inline-block;
    top: 2px;
  }

  & > span::after {
    transform: rotate(45deg);
  }

  & > span::before {
    transform: rotate(-45deg);
  }

  &.selected {
    color: #0fa457;
    font-weight: 500;
    border: 1px solid #0fa457;
    background: #f3faf7;
  }
`;

export const ListWrapper = styled.div`
  padding: 20px 20px;
  position: relative;
  background: #fff;
  z-index: 1;
`;

export const LoadingMoreGarages = styled.div`
  margin: 20px auto;
  text-align: center;
`;

export const NoGarageFoundWrapper = styled(Flex)`
  min-height: 400px;
  flex-direction: column;
  border-radius: 0px 0px 16px 16px;

  @media (min-width: 768px) {
    min-height: 304px;
  }
`;
export const NoGarageFound = styled(Text)`
  font-family: "Euclid Circular B";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-top: 12px;
`;
